var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "correct") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ItemPath",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ItemPath-Reports-Copy",
    transform: "translate(-283.000000, -113.000000)",
    fill: "#0B8400",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "correct",
    transform: "translate(283.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.65837695,15.6917631 C7.46746447,15.8896127 7.20699328,16 6.93642483,16 C6.66585638,16 6.40538519,15.8896127 6.21447271,15.6917631 L0.448765894,9.75049667 C-0.149588631,9.13402285 -0.149588631,8.13437203 0.448765894,7.51905413 L1.17071801,6.77504726 C1.76925956,6.15857345 2.73840687,6.15857345 3.33676139,6.77504726 L6.93642483,10.4839079 L16.6632386,0.462355364 C17.2617801,-0.154118455 18.2318624,-0.154118455 18.829282,0.462355364 L19.5512341,1.20636223 C20.1495886,1.82283605 20.1495886,2.82229418 19.5512341,3.43780477 L7.65837695,15.6917631 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.9fc1343244311040447515fa459e284e.svg";
export { ForwardRef as ReactComponent };